import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

const card = "bg-white dark:bg-neutral-900 border border-brand-line dark:border-neutral-800 rounded-2xl";

export default function Orders() {
  const [orders, setOrders] = useState(null);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  useEffect(() => { load(); }, []);

  const refund = async (id) => {
    const reason = window.prompt("Enter a refund reason (optional), then click OK to confirm the FULL refund:");
    if (reason === null) return;
    try { const { data: r } = await api.post("/admin/refund", { session_id: id, reason }); toast.success(`Refunded $${r.refunded}`); load(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  const badge = (s) => ({ paid: "bg-green-100 text-green-700", refunded: "bg-blue-100 text-blue-700", pending: "bg-amber-100 text-amber-700", failed: "bg-red-100 text-red-700", expired: "bg-neutral-200 text-neutral-600" }[s] || "bg-neutral-200");
  const list = (orders || []).filter((o) => !q || `${o.customer} ${o.item} ${o.kind}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="orders-page">
      <h1 className="font-display text-4xl">Orders</h1>
      <p className="text-brand-ink/60 dark:text-white/50 mt-2">Every purchase with its PayPal transaction and status.</p>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search orders…" className="mt-6 w-full max-w-sm rounded-xl border border-brand-line dark:border-neutral-700 dark:bg-neutral-900 px-4 py-2.5 text-sm focus:ring-2 focus:ring-brand-red focus:outline-none" data-testid="orders-search" />
      <div className={`${card} mt-6 overflow-hidden`}>
        {!orders ? <div className="p-6 text-brand-ink/50">Loading…</div> : list.length === 0 ? <div className="p-6 text-brand-ink/50 dark:text-white/40" data-testid="orders-empty">No orders found.</div> : (
          <div className="divide-y divide-brand-line dark:divide-neutral-800">
            {list.map((o) => (
              <div key={o.order_id} className="px-6 py-4 flex items-center justify-between flex-wrap gap-3" data-testid={`order-${o.order_id.slice(0, 12)}`}>
                <div>
                  <div className="font-medium capitalize">{o.item} <span className="text-brand-ink/40 dark:text-white/40 text-sm">· {o.customer || "—"} · {o.date}</span></div>
                  <div className="text-xs text-brand-ink/40 dark:text-white/40 font-mono">PayPal: {(o.paypal_txn || "").slice(0, 24)}…</div>
                </div>
                <div className="flex items-center gap-4">
                  <span className="font-display text-xl">${(o.amount || 0).toFixed(2)}</span>
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${badge(o.status)}`}>{o.status}</span>
                  {o.status === "paid" && <button onClick={() => refund(o.order_id)} className="inline-flex items-center gap-1 text-sm text-brand-red hover:underline" data-testid={`order-refund-${o.order_id.slice(0, 12)}`}><RotateCcw className="w-4 h-4" /> Refund</button>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
